<template>
  <div>
    <el-alert
      title="This survey has been published. Questions will not be editable."
      type="warning"
      show-icon
      v-if="!survey.isPreview"
    ></el-alert>
    <div class="col-md-8 canvas-wrapper">
      <el-card class="canvas-card" shadow="never" :body-style="{ padding: 0 }">
        <question-canvas :isEditable="survey.isPreview"></question-canvas>
      </el-card>
    </div>

    <div class="col-md-4 selector-wrapper" ref="selectorWrapper">
      <el-card
        class="selector-card"
        shadow="never"
        ref="selectorCard"
        :body-style="{ padding: '0 6px' }"
        :class="{ 'selector-fixed': selectorFixed }"
        :style="selectorStyle"
      >
        <el-tabs v-model="currentTab">
          <el-tab-pane label="Qualitative" name="qualitative">
            <qualitative-selector-tab :selectorFixed="selectorFixed"></qualitative-selector-tab>
          </el-tab-pane>

          <el-tab-pane label="Music" name="music" v-if="survey.surveyType === 'MUSIC'">
            <music-selector-tab :selectorFixed="selectorFixed"></music-selector-tab>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>

    <choice-category-create-dialog></choice-category-create-dialog>
    <choice-template-save-dialog></choice-template-save-dialog>
    <hook-save-dialog></hook-save-dialog>
    <matrix-choice-save-dialog></matrix-choice-save-dialog>
    <matrix-conditional-logic-dialog></matrix-conditional-logic-dialog>
    <question-category-create-dialog></question-category-create-dialog>
    <question-conditional-logic-dialog></question-conditional-logic-dialog>
    <question-save-dialog></question-save-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ChoiceCategoryCreateDialog from '../dialogs/ChoiceCategoryCreateDialog';
import ChoiceTemplateSaveDialog from '../dialogs/ChoiceTemplateSaveDialog';
import HookSaveDialog from '../dialogs/HookSaveDialog';
import MatrixChoiceSaveDialog from '../dialogs/MatrixChoiceSaveDialog';
import MatrixConditionalLogicDialog from '../dialogs/MatrixConditionalLogicDialog';
import MusicSelectorTab from '../selectors/MusicSelectorTab';
import QualitativeSelectorTab from '../selectors/QualitativeSelectorTab';
import QuestionCanvas from '../editors/QuestionCanvas';
import QuestionCategoryCreateDialog from '../dialogs/QuestionCategoryCreateDialog';
import QuestionConditionalLogicDialog from '../dialogs/QuestionConditionalLogicDialog';
import QuestionSaveDialog from '../dialogs/QuestionSaveDialog';

// At what height should we fix the selector
const SELECTOR_STICK = 200;

export default {
  name: 'CanvasTab',
  components: {
    ChoiceCategoryCreateDialog,
    ChoiceTemplateSaveDialog,
    HookSaveDialog,
    MatrixChoiceSaveDialog,
    MatrixConditionalLogicDialog,
    MusicSelectorTab,
    QualitativeSelectorTab,
    QuestionCanvas,
    QuestionCategoryCreateDialog,
    QuestionConditionalLogicDialog,
    QuestionSaveDialog,
  },
  data: () => ({
    selectorFixed: false,
    selectorFixedWidth: 0,
    selectorHeightModifier: 0,
    currentTab: 'qualitative',
  }),
  computed: {
    ...mapState('surveybuilder', ['survey']),

    selectorStyle() {
      if (this.selectorFixed && this.$refs.selectorWrapper) {
        const width = this.$refs.selectorWrapper.clientWidth + 20;
        return { width: `${width}px` };
      }
      return {
        'min-height': `calc(100vh - ${210 - this.selectorHeightModifier}px`,
      };
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.selectorFixed = window.scrollY >= SELECTOR_STICK;
      this.selectorHeightModifier = window.scrollY;
    },
  },
};
</script>

<style lang="scss" scoped>
.canvas-wrapper,
.selector-wrapper {
  padding-left: 0;
}

.canvas-card,
.selector-card {
  min-height: calc(100vh - 210px);
}

.selector-fixed {
  position: fixed;
  top: 0;
  min-height: calc(100vh);
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// CanvasTab.vue?725ec1cc